import React from 'react'

export default function FamilyReferralSection() {
    return (
        <div style={{
            border: '1px solid #e2e4e9',
            borderRadius: 6,
            marginBottom: 16
        }}>
            <div
                style={{
                    borderBottom: '1px solid #e2e4e9',
                    padding: 8,
                    background: '#f0f2f44d',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                }}
            >
                {/* <CommentOutlined /> */}
                <span style={{
                    fontWeight: 600,
                    fontFamily: 'tradeGothic',
                    fontSize: 14
                }}>
                    Family Members & Referrals
                </span>
            </div>
            <div style={{ padding: 8 }}>
                All family members and referral associations from both profiles should be merged.        
            </div>
        </div>
    )
}
